module.exports = __webpack_public_path__ + "img/tree.d90614e9.png";